import React, {useContext} from 'react'
import DatePicker from 'react-datepicker'
import {useTranslation} from 'react-i18next'
import {InputGroup, Form} from 'react-bootstrap'
import {withTranslation} from 'react-i18next'
import CustomDateInput from '../AuditDateInput'
import {AuditDetailsContext} from '../../../../context/Modal/AuditDetails'
import {AuditModalApiContext} from '../../../../context/AuditModalApi'
import {AuditModalBarContext} from '../../../../context/AuditModalBar'
import {AuditPaneContext} from '../../../../context/AuditPane'
import {AuditContext} from '../../../../context/Audits'
import {GroupDetailsContext} from '../../../../context/Modal/GroupDetails'
import {AssignAuditContext} from '../../../../context/Modal/AssignAudit'
import {RecurringDetailsContext} from '../../../../context/Modal/RecurringDetails'
import {normalizeDate} from '../../../../utils/normalizeData'
import {UserContext} from '../../../../context/User'
import {TemplatesContext} from '../../../../context/Templates'
import {AuditValidateForm} from '../../../../utils/AuditValidateForm'
import {ToastMessageContext} from '../../../../context/ToastMessage'

function ScheduleAudit() {
  const {
    id,
    name,
    method,
    start_date,
    due_date,
    due_soon_days,
    allow_scanning_after_due_date,
    gps_location,
    asset_details,

    setName,
    setStartDate,
    setDueDate,
    setDueSoonDays,
    setAllowScanningAfterDurDate,
    resetAuditDetails,
  } = useContext(AuditDetailsContext)
  const {resetRecurringDetails} = useContext(RecurringDetailsContext)
  const {resetEntities, resetEntityDetails} = useContext(AuditModalApiContext)
  const paneState = useContext(AuditPaneContext)
  const modalBar = useContext(AuditModalBarContext)
  const {setBarState, resetBarDetails} = useContext(AuditModalBarContext)
  const user = useContext(UserContext)
  const {getAll, addAudit, searchParams} = useContext(AuditContext)
  const {getAudits, updateTemplateCount} = useContext(TemplatesContext)
  const [loader, setLoader] = React.useState(false)
  const {
    audit_entities_attributes,
    allow_auto_update_fields,
    allow_user_update_fields,
    allow_user_without_edit_permission,
    resetGroupsDetails,
  } = React.useContext(GroupDetailsContext)
  const {
    individual_audit,
    audit_users_attributes,
    audit_email_users_attributes,
    audit_user_templates_attributes,
    resetAssignDetails,
  } = React.useContext(AssignAuditContext)

  const {t} = useTranslation()
  const auditDetails = useContext(AuditDetailsContext)
  const recurring = useContext(RecurringDetailsContext)
  const barState = useContext(AuditModalBarContext)
  const toast = useContext(ToastMessageContext)

  const modalState = {auditDetails, paneState, recurring, barState}
  const auditData = () => {
    return {
      template_id: id,
      name,
      method,
      start_date: normalizeDate(start_date),
      due_date: due_date ? normalizeDate(due_date) : '31/12/2100',
      asset_details,
      gps_location,
      individual_audit,
      allow_scanning_after_due_date,
      user_id: user.details.id,
      account_id: user.details.account_id,
      due_soon_days,
      audit_entities_attributes,
      allow_user_update_fields,
      allow_user_without_edit_permission,
      allow_auto_update_fields,
      audit_users_attributes,
      audit_email_users_attributes,
      audit_user_templates_attributes,
      type: 'scheduled-audit',
      timezone: user.details.timezone,
    }
  }

  const tosterAlertPopup = response => {
    if (response !== null && response.status !== 500) {
      if (
        response.data.errors &&
        response.data.errors[0].base &&
        response.data.errors[0].base[0] !== undefined
      ) {
        toast.popMessage(response.data.errors[0].base[0], 'error')
      } else {
        toast.popMessage('Internal Server Error', 'error')
      }
    } else {
      toast.popMessage('Internal Server Error', 'error')
    }
  }

  async function saveScheduleAuditInfo() {
    if (!loader) {
      let audit = auditData()
      try {
        setLoader(true)
        addAudit(audit).then(response => {
          if (response.id !== undefined) {
            toast.popMessage(`${response.name} is saved successfully`, 'success')
            paneState.closeModal()
            getAll({start: 1, ...searchParams})
            updateTemplateCount(audit.template_id)
            if (paneState.isExpandOpen) getAudits({template_id: audit.template_id, ...searchParams})
          } else {
            tosterAlertPopup(response)
            setLoader(false)
          }
        })
      } catch (e) {
        console.log(`Create Audit failed: ${audit.name}`)
      }
    }
  }

  const handleSubmit = () => {
    AuditValidateForm(0, modalState).then(err => {
      if (err.length > 0) {
        setBarState({
          ...barState,
          errors: err,
        })
      } else {
        saveScheduleAuditInfo()
      }
    })
  }

  const resetDetails = () => {
    paneState.closeModal()
    resetAuditDetails()
    resetGroupsDetails()
    resetAssignDetails()
    resetRecurringDetails()
    resetBarDetails()
    resetEntities()
    resetEntityDetails()
  }

  let nameError, startDateError, dueDateError, dueSoonDaysError

  if (modalBar.errors.length > 0) {
    modalBar.errors.map(err => {
      switch (err.error_field) {
        case 'name':
          nameError = err
          break
        case 'start_date':
          startDateError = err
          break
        case 'due_date':
          dueDateError = err
          break
        case 'due_soon_days':
          dueSoonDaysError = err
          break
        default:
          break
      }
      return true
    })
  }

  return (
    <form className="audit-forms form-data schedule-modal">
      <div className="col-12">
        <label
          className={
            nameError ? 'required width-100-persent required-circle' : 'required width-100-persent'
          }
        >
          {t('audit.form-schedule-audit.audit-name')}
        </label>
        <input
          className="form-control"
          type="text"
          placeholder="Name"
          onChange={e => {
            setName(e.target.value)
            modalBar.handleNameLoading()
          }}
          value={name}
          required
        />
        {nameError && <div className="text-danger mb-8">{nameError.error_message}</div>}
      </div>
      <div className="row col-12 padding-right-0 datepicker_tab_1 datepicker_position">
        <div className="col-6 padding-right-0">
          <label
            className={
              startDateError
                ? 'required width-100-persent required-circle'
                : 'required width-100-persent'
            }
            style={{marginTop: 14}}
          >
            Start Date
          </label>
          <InputGroup>
            <DatePicker
              placeholderText="mm/dd/yyyy"
              className="form-control"
              onChange={e => setStartDate(e)}
              minDate={new Date()}
              showYearDropdown
              yearDropdownItemNumber={5}
              dateFormatCalendar="MMMM"
              scrollableYearDropdown
              selectsStart
              customInput={<CustomDateInput id="start_date" />}
              selected={start_date ? new Date(start_date) : ''}
              startDate={start_date ? new Date(start_date) : ''}
              endDate={due_date ? new Date(due_date) : ''}
              name="start_date"
            />
          </InputGroup>
          {startDateError && <div className="text-danger mb-8">{startDateError.error_message}</div>}
        </div>
        <div className="col-6 padding-right-0 due_date">
          <label style={{marginTop: 14}}>Due Date</label>
          <InputGroup>
            <DatePicker
              placeholderText="mm/dd/yyyy"
              className="form-control"
              onChange={e => setDueDate(e)}
              minDate={new Date(start_date)}
              showYearDropdown
              yearDropdownItemNumber={5}
              dateFormatCalendar="MMMM"
              scrollableYearDropdown
              selectsEnd
              customInput={<CustomDateInput id="due_date" />}
              selected={due_date ? new Date(due_date) : ''}
              startDate={start_date ? new Date(start_date) : ''}
              endDate={due_date ? new Date(due_date) : ''}
              name="due_date"
            />
          </InputGroup>
          {dueDateError ? (
            <div className="text-danger mb-8">{dueDateError.error_message}</div>
          ) : (
            <small>Optional</small>
          )}
        </div>
      </div>
      {due_date && (
        <>
          <div className="styled_checkbox col-12 mt-10">
            <div className="option_1">
              <Form.Check
                className="css-checkbox lrg"
                type="checkbox"
                aria-label="option 1"
                label="Allow Scanning after due date."
                onChange={() => setAllowScanningAfterDurDate(!allow_scanning_after_due_date)}
                checked={allow_scanning_after_due_date}
              />
            </div>
          </div>
          <div className="col-12" style={{marginTop: 8}}>
            <label
              className={
                dueSoonDaysError ? 'width-100-persent required-circle' : 'width-100-persent'
              }
            >
              Due Soon Notification
            </label>
            <div className="col-12 row">
              <input
                className="form-control height-100 input-padding-0 padding-0-13"
                style={{padding: '0 4px', textAlign: 'center'}}
                type="number"
                min={0}
                max={365}
                onChange={e => setDueSoonDays(e.target.value)}
                value={due_soon_days}
                required
              />
              <span className="col-9" style={{paddingTop: '6px', color: '#585a5d', fontSize: 14}}>
                days before due date
              </span>
            </div>
            {dueSoonDaysError && (
              <div className="text-danger mb-8">{dueSoonDaysError.error_message}</div>
            )}
          </div>
        </>
      )}
      <div className="row col-12 padding-right-0" style={{position: 'absolute', bottom: '15px'}}>
        <div className="btn schedule-cancel-btn" onClick={paneState.closeModal}>
          Cancel
        </div>
        <div className="btn schedule-form-btn btn-green" onClick={() => handleSubmit()}>
          {loader ? t('audit.audit-modal.running-audit') : t('audit.audit-modal.run-audit')}
        </div>
      </div>
    </form>
  )
}

export default withTranslation()(ScheduleAudit)
